<template>
  <div class="main">
      <tab title='加油记录详情'></tab>
      <div class="top">
          <div class="top_amount">
                {{item.realAmount}}元
          </div>
          <div class="amount_d">
              结算金额
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              订单状态
          </div>
          <div class="oli_right">
              {{item.statusName}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              公司名称
          </div>
          <div class="oli_right">
              {{item.merchantName}}
          </div>
      </div>    
      <div class="oli">
          <div class="oli_left">
              撬站名称
          </div>
          <div class="oli_right">
              {{item.stationName}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              订单编号
          </div>
          <div class="oli_right">
              {{item.orderNo}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              油品类型
          </div>
          <div class="oli_right">
              {{item.qualityModel}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              油枪编号
          </div>
          <div class="oli_right">
              {{item.gunCode}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              挂牌价格（元/升）
          </div>
          <div class="oli_right">
              {{item.listPrice}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              结算价格（元/升）
          </div>
          <div class="oli_right">
              {{item.salePrice}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              加油量（L）
          </div>
          <div class="oli_right">
              {{item.num}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              交易金额（元）
          </div>
          <div class="oli_right">
              {{item.tradeAmount}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              结算金额（元）
          </div>
          <div class="oli_right">
              {{item.realAmount}}
          </div>
      </div>
       <div class="oli" v-if="item.refundAmount&&item.refundAmount!=''">
          <div class="oli_left">
              退款金额（元）
          </div>
          <div class="oli_right">
              {{item.refundAmount}}
          </div>
      </div>
      <div class="oli" v-if="item.refundTime&&item.refundTime!=''">
          <div class="oli_left">
              退款时间
          </div>
          <div class="oli_right">
              {{item.refundTime}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              卡号
          </div>
          <div class="oli_right">
              {{item.cardNo}}
          </div>
      </div>
      <div class="oli" v-if="item.carLimit!=''&&item.carLimit!=null">
          <div class="oli_left">
              车牌号码
          </div>
          <div class="oli_right">
              {{item.carLimit}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              卡余额（元）
          </div>
          <div class="oli_right">
              {{item.afterBalance}}
          </div>
      </div>
      <div class="oli">
          <div class="oli_left">
              交易时间
          </div>
          <div class="oli_right">
              {{item.completeTime}}
          </div>
      </div>
      <!-- <div class="oli">
          <div class="oli_left">
              累计交易量（元）
          </div>
          <div class="oli_right">
              {{item.aTot}}
          </div>
      </div> -->
      <!-- <div class="oli">
          <div class="oli_left">
              TTC号
          </div>
          <div class="oli_right">
              {{item.ttc}}
          </div>
      </div> -->
  </div>
</template>

<script>
import tab from '@/components/NavBar'

export default {
  name: 'margin',
  data () {
    return {
        item:{}
    }
  },
  components:{
      tab
  },
  mounted(){
      this.item=this.$route.params.item
      console.log(this.item)

  }
}
</script>

<style scoped>
.main {
    background-color: #F7F8FA;
    height: 100vh;
}
.top{
    height: 15%;
    width: 100%;
    background-color: #fff;
    padding-top: 20px;

}
.top_amount {
    /* width: 100px; */
    height: 40px;
    margin: auto;
    text-align: center;
    font-size: 28px;
    font-weight: 700;
}
.amount_d {
    width: 100px;
    font-size: 16px;
    text-align: center;
    margin: auto;
    color: #7c8485;
}
.oli {
    width: 100%;
    height: 35px;
    line-height: 35px;
    background-color: #fff;
    font-size: 16px;
    display: flex;
}
.oli_left {
    width: 38%;
    margin-left: 10px;
    color: #999999;
}
.oli_right {
    width: 62%;
    text-align: right;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ComeOn_record_detail.vue